document.addEventListener("DOMContentLoaded", function(){

  const gallery = document.querySelector("[data-product-gallery]");
  if(!gallery) return;

  const slides = gallery.querySelectorAll("[data-gallery-slide]");
  const thumbs = gallery.querySelectorAll("[data-thumb-index]");
  const images = gallery.querySelectorAll(".product-gallery__image");
  const videos = gallery.querySelectorAll("video");

  const prev = gallery.querySelector("[data-gallery-prev]");
  const next = gallery.querySelector("[data-gallery-next]");

  const zoomHint = gallery.querySelector('[data-zoom-hint]');

  const lightbox = document.querySelector("[data-lightbox]");
  const lightboxImg = document.querySelector(".lightbox-image");
  const closeBtn = document.querySelector(".lightbox-close");

  let current = 0;

  const activeVideo = document.querySelector('.is-active[data-media_type="video"]');

  if (activeVideo) {
      zoomHint.style.opacity = "0" ;
  }




  function showSlide(index){
    slides.forEach(s => s.classList.remove("is-active"));
    thumbs.forEach(t => t.classList.remove("is-active"));
    const currentSlide = slides[index];
    currentSlide.classList.add("is-active");
    if(thumbs[index]) thumbs[index].classList.add("is-active");

    current = index;

    /* STOP VIDEOS */
    videos.forEach(v => {
      if(!v.paused) v.pause();
    });

    const isVideo = currentSlide.querySelector("video, iframe");
    if (zoomHint) {
      zoomHint.style.opacity = isVideo ? "0" : "1";
    }
  }

  /* THUMB CLICK */
  thumbs.forEach(thumb => {
    thumb.addEventListener("click", function(){
      showSlide(parseInt(this.dataset.thumbIndex));
    });
  });

  /* ARROWS */
  if(next){
    next.addEventListener("click", function(){
      showSlide((current + 1) % slides.length);
    });
  }
  if(prev){
    prev.addEventListener("click", function(){
      showSlide((current - 1 + slides.length) % slides.length);
    });
  }

  /* HOVER ZOOM */
  slides.forEach(slide => {
    const img = slide.querySelector(".product-gallery__image");
    if(!img) return;

    slide.addEventListener('mouseenter', function () {
      img.style.transform = 'scale(2)';
      console.log("endter")
      if (zoomHint) zoomHint.style.opacity = '0';
    });

    slide.addEventListener("mousemove", function(e){
      if(window.innerWidth < 768) return;

      const rect = slide.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = x + "% " + y + "%";
      img.style.transform = "scale(2)";
    });

    slide.addEventListener("mouseleave", function(){
      img.style.transform = "scale(1)";
      if (zoomHint) zoomHint.style.opacity = '1';
    });
  });

  /* LIGHTBOX (ONLY IMAGE) */
  images.forEach(img => {
    img.addEventListener("click", function(){
      if(window.innerWidth < 768){
        lightboxImg.src = img.dataset.full || img.src;
        lightbox.classList.add("active");
        document.body.style.overflow = "hidden";
      }
    });
  });

  /* CLOSE LIGHTBOX */
  if(closeBtn){
    closeBtn.addEventListener("click", function(){
      lightbox.classList.remove("active");
      document.body.style.overflow = "";
    });
  }

  /* SWIPE */
  let startX = 0;

  gallery.addEventListener("touchstart", function(e){
    startX = e.touches[0].clientX;
  });

  gallery.addEventListener("touchend", function(e){
    let endX = e.changedTouches[0].clientX;

    if(startX - endX > 50){
      showSlide((current + 1) % slides.length);
    }
    if(endX - startX > 50){
      showSlide((current - 1 + slides.length) % slides.length);
    }
  });

});